import React from "react";
import { Box, Grid } from "@mui/material";
import { useRouteMatch } from "react-router-dom";

import {
  Evaluations,
  IntercomData,
  FreeResets,
  CustomerNotes,
  ComplianceNotes,
} from "../../../pages/Customer/components/";
import { BanAccount, BaseCustomerInfo } from "../index";
import { useAdminProviderDataContext } from "../../../context";
import * as FTComponents from "../../../pages/FundedTrader/components";

const MainCustomerInfo: React.FC = () => {
  const {
    user: { allowed_features },
  } = useAdminProviderDataContext();
  const matchCustomerPage = useRouteMatch("/customer/:id");
  const matchFundedTraderPage = useRouteMatch("/fundedTraders/:id");

  return (
    <Grid container spacing={3} sx={{ minHeight: "350px" }}>
      <Grid item xs={4}>
        <BaseCustomerInfo />
      </Grid>
      <Grid item xs={3}>
        {matchFundedTraderPage && (
          <Box sx={{ display: "grid", rowGap: "8px" }}>
            <FTComponents.PEPSelect />
            <FTComponents.E2TAffiliateValue />
            <FTComponents.E2TInterview />
            <FTComponents.OnVocationUntilDateSelect />
            {/* <FTComponents.FundedTraderStatus /> */}
            <FTComponents.PriorityStatusControls />
            <FTComponents.ProfessionalLiveSimData />
            <FTComponents.Over8KWithdrawals />
            <FTComponents.ForcedToLive />
            <FTComponents.ToggleStartNextMonth />
          </Box>
        )}
        {matchCustomerPage && (
          <>
            {allowed_features.read_customer_intercom_data && <IntercomData />}
            <Evaluations />
            <FreeResets />
          </>
        )}
      </Grid>
      <Grid item xs={5}>
        {allowed_features.ban_account && <BanAccount />}
        <CustomerNotes isShowSuspiciousNotes />
        {matchFundedTraderPage && <FTComponents.FundedProfileNotesTable />}
        {matchCustomerPage && (
          <Box mt="5px">
            <CustomerNotes />
            <ComplianceNotes />
          </Box>
        )}
      </Grid>
    </Grid>
  );
};

export default MainCustomerInfo;
